module.exports = __webpack_public_path__ + "img/2.9e5e5180.jpg";